import { render, staticRenderFns } from "./CourseChecklistItem.vue?vue&type=template&id=40b5582c&lang=pug&"
import script from "./CourseChecklistItem.vue?vue&type=script&lang=js&"
export * from "./CourseChecklistItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseChecklistItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports